import { all, put, call, takeLatest } from "redux-saga/effects";

import { request } from "../../services/client";
import { ActionTypes } from "../constants/actions";
import { APIEndpoints } from "../constants";
import { getCookie } from "../../services/cookie";

const role = getCookie('role')

export function* createTicket({ payload }) {
  try {
    const {
      title,
      description,
      assigned_to_id,
      ticket_scope,
      ticket_scope_id,
      ticket_type,
      ticket_severity,
      internal
    } = payload;
    let inputPayload = {
      title,
      description,
      assigned_to_id,
      ticket_scope,
      ticket_scope_id,
      ticket_type,
      ticket_severity,
      internal
    };
    let apiUrl = APIEndpoints.CREATE_TICKET
    if(payload.isAuditor) {
      
      // apiUrl = APIEndpoints.CREATE_TICKET_AUDITOR 
      apiUrl = payload.companyId ? APIEndpoints.COMPANY_CREATE_TICKET(payload) : APIEndpoints.CREATE_TICKET_AUDITOR;
    }
    else if (payload.companyId) {
      apiUrl = payload.isAuditor ? APIEndpoints.CREATE_TICKET_AUDITOR : APIEndpoints.COMPANY_CREATE_TICKET(payload);
      delete inputPayload.assigned_to_id;
    }
    const response = yield call(request, apiUrl, {
      method: "POST",
      payload: inputPayload,
    });
    yield put({
      type: ActionTypes.CREATE_TICKET_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.CREATE_TICKET_FAILURE,
      payload: err,
    });
  }
}

export function* closeTicket({ payload }) {
  try {
    const apiUrl = payload.companyId
      ? APIEndpoints.COMPANY_CLOSE_TICKET(payload)
      : payload.isAuditor ? APIEndpoints.CLOSE_TICKET_AUDITOR(payload) : APIEndpoints.CLOSE_TICKET(payload);
    const response = yield call(request, apiUrl, {
      method: "POST",
      payload,
    });
    yield put({
      type: ActionTypes.CLOSE_TICKET_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.CLOSE_TICKET_FAILURE,
      payload: err,
    });
  }
}

export function* deleteTicket({ payload }) {
  try {
    const apiUrl = payload.companyId
      ? APIEndpoints.GET_COMPANY_TICKET_DETAILS(payload)
      : APIEndpoints.GET_TICKET_DETAILS(payload);
    const response = yield call(request, apiUrl, {
      method: "DELETE",
      payload,
    });
    yield put({
      type: ActionTypes.DELETE_TICKET_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.DELETE_TICKET_FAILURE,
      payload: err,
    });
  }
}

export function* listTickets({ payload }) {
  try {
    const apiUrl = payload.company
      ? APIEndpoints.COMPANY_LIST_TICKETS(payload)
      : payload.isAuditor ? APIEndpoints.LIST_AUDITOR_TICKETS(payload) : APIEndpoints.LIST_TICKETS(payload);      
    const response = yield call(request, apiUrl, {
      method: "GET",
    });
    yield put({
      type: ActionTypes.LIST_TICKETS_SUCCESS,
      payload: response,
    });
  } 
  catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.LIST_TICKETS_FAILURE,
      payload: err,
    });
  }
}

export function* listScopeTickets({ payload }) {
  try {
    const {scope, scopeId, isAuditor, company} = payload
    const apiEndpoint = isAuditor ? APIEndpoints.LIST_AUDITOR_SCOPE_TICKETS(scope, scopeId, company) : APIEndpoints.LIST_SCOPE_TICKETS(scope, scopeId)
    const response = yield call(request, apiEndpoint, {
      method: "GET",
    });
    yield put({
      type: ActionTypes.LIST_SCOPE_TICKETS_SUCCESS,
      payload: response.tickets,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.LIST_SCOPE_TICKETS_FAILURE,
      payload: err,
    });
  }
}

export function* getTicketDetails({ payload }) {
  try {
    const apiUrl = payload.companyId
      ? APIEndpoints.GET_COMPANY_TICKET_DETAILS(payload)
      : (payload.isAuditor ? APIEndpoints.GET_AUDITOR_TICKET_DETAILS(payload) : APIEndpoints.GET_TICKET_DETAILS(payload));
    const response = yield call(request, apiUrl, {
      method: "GET",
    });
    yield put({
      type: ActionTypes.GET_TICKET_DETAILS_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.GET_TICKET_DETAILS_FAILURE,
      payload: err,
    });
  }
}

export function* addResponse({ payload }) {
  try {
    const apiUrl = payload.companyId
      ? APIEndpoints.COMPANY_ADD_RESPONSE(payload)
      : payload.isAuditor ? APIEndpoints.ADD_RESPONSE_AUDITOR(payload) : APIEndpoints.ADD_RESPONSE(payload);
    const response = yield call(request, apiUrl, {
      method: "POST",
      payload: {
        response: payload.response,
      },
    });
    yield put({
      type: ActionTypes.ADD_COMMENT_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.ADD_COMMENT_FAILURE,
      payload: err,
    });
  }
}

export function* updateTicket({ payload }) {
  try {
    const {
      ticketId,
      title,
      description,
      assigned_to_id,
    } = payload;
    let inputPayload = {
      title,
      description,
      assigned_to_id,
    };
    let apiUrl = APIEndpoints.UPDATE_TICKET(ticketId);
    
    const response = yield call(request, apiUrl, {
      method: "PUT",
      payload: inputPayload,
    });
    yield put({
      type: ActionTypes.UPDATE_TICKET_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.UPDATE_TICKET_FAILURE,
      payload: err,
    });
  }
}

export default function* root() {
  yield all([
    takeLatest(ActionTypes.CREATE_TICKET, createTicket),
    takeLatest(ActionTypes.CLOSE_TICKET, closeTicket),
    takeLatest(ActionTypes.DELETE_TICKET, deleteTicket),
    takeLatest(ActionTypes.LIST_TICKETS, listTickets),
    takeLatest(ActionTypes.LIST_SCOPE_TICKETS, listScopeTickets),
    takeLatest(ActionTypes.GET_TICKET_DETAILS, getTicketDetails),
    takeLatest(ActionTypes.ADD_RESPONSE, addResponse),
    takeLatest(ActionTypes.UPDATE_TICKET, updateTicket),
  ]);
}
